module.exports = __webpack_public_path__ + "static/media/the-race-to-improve-food-security.c34d1ca3.jpg";